import * as React from "react";
import {useEffect, useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {Button} from "web-com";
import "./style.scss";
import {ContainerBox} from "myshubhlife-component/container-box";
import {COLOR} from "utils/variables";
import {IScreens, IValidMinMax} from "IncompleteInfoV2/interface";
import {pageTitle, removeExistingError, ScreenNames} from "IncompleteInfoV2/utils";
import {BankAccount} from "IncompleteInfoV2/LoanRequest/BankAccount";
import {LoanDetails} from "IncompleteInfoV2/LoanRequest/LoanDetails";
import {IProfile} from "StateInterface";
import {
    getBankAccountInitialState,
    getLoanInitialState, getMinMaxLoanDetails,
    IBankAccountProfile,
    ILoanProfile, updateProfile,
} from "IncompleteInfoV2/LoanRequest/utils";
import {validations} from "IncompleteInfoV2/validations";
import {saveLamProfile} from "profile/api";
import {updateSubStatuses} from "IncompleteInfoV2/api";
import {removeCompletedSubStatus, showToast} from "IncompleteInfoV2/actions";
import {history} from "load/store";
import Loading from "components/loading";
import {getFinancialDetails, updateLoanRequirement} from "IncompleteInfoV2/LoanRequest/api";
import {ILatestStatus} from "profile/interface";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    screens: IScreens;
    profile: IProfile;
    applicationId: number;
    applicationInfo: ILatestStatus;
    isAndroid: boolean;
}

enum LoanRequestSubStatus {
    BANK_DETAILS_INCOMPLETE = "BANK_DETAILS_INCOMPLETE",
    LOAN_REQUEST_INCOMPLETE = "LOAN_REQUEST_INCOMPLETE",
}

const LoanRequest = (props: IConnectProps & RouteComponentProps) => {
    const [loanProfile, setLoanProfile] = useState<ILoanProfile>(getLoanInitialState(props.profile));
    const [bankAccountProfile, setBankAccountProfile] = useState<IBankAccountProfile>(getBankAccountInitialState(props.profile));
    const [errors, setErrors] = useState<{[key: string]: string}>({});
    const subStatus = props.screens && props.screens[ScreenNames.LOAN_REQUEST] && props.screens[ScreenNames.LOAN_REQUEST].subStatuses;
    const [loading, setLoading] = useState(false);
    const [minMax, setMinMax] = useState<IValidMinMax>(null);
    useEffect(() => {
        if (subStatus && subStatus.includes(LoanRequestSubStatus.LOAN_REQUEST_INCOMPLETE)) {
            (async () => {
                try {
                    setLoading(true);
                    const response = await getFinancialDetails(props.applicationInfo.productType);
                    if (response) {
                        setLoading(false);
                        setMinMax(getMinMaxLoanDetails(response.loanBoundary));
                    }
                } catch (e) {
                    history.goBack();
                }
            })();
        }
    }, []);
    const handleSubmit = async () => {
        const validationResult = validations({...(subStatus &&
          subStatus.includes(LoanRequestSubStatus.LOAN_REQUEST_INCOMPLETE) ? loanProfile : {}), ...(subStatus &&
          subStatus.includes(LoanRequestSubStatus.BANK_DETAILS_INCOMPLETE) ?
          bankAccountProfile : {} as IBankAccountProfile)}, minMax);
        if (Object.keys(validationResult).length) {
            setErrors(validationResult);
        } else {
            try {
                setLoading(true);
                const saveProfile  = await saveLamProfile(props.userId, updateProfile({...loanProfile, ...bankAccountProfile}), null, null);
                if (saveProfile.status === 200) {
                    let updateSubStatus = true;
                    if (subStatus && subStatus.includes(LoanRequestSubStatus.LOAN_REQUEST_INCOMPLETE)) {
                        const res = await updateLoanRequirement({
                          applicationId: props.applicationId,
                          amountRequested: loanProfile.amount,
                          tenureRequested: loanProfile.tenure,
                          purpose: loanProfile.purpose});
                        if (res.status !== 200) {
                            updateSubStatus = false;
                        }
                    }
                    if (updateSubStatus) {
                        const removeStatus = await updateSubStatuses(props.applicationId, props.screens[ScreenNames.LOAN_REQUEST].subStatuses);
                        if (removeStatus.status === 200) {
                            props.dispatch(showToast(COLOR.GREEN, `${pageTitle.loanRequest} updated successfully`));
                            props.dispatch(removeCompletedSubStatus(ScreenNames.LOAN_REQUEST));
                            setLoading(false);
                            history.goBack();
                        }
                    }
                }
            } catch (err) {
                setLoading(false);
            }
        }
    };

    const handleLoanProfileChange = (fieldName: string, value: string) => {
        if (errors[fieldName]) {
            setErrors(removeExistingError(errors, fieldName));
        }
        setLoanProfile((state) => ({...state, [fieldName]: value}));
    };

    const handleBankAccountProfileChange = (fieldName: string, value: string) => {
        if (errors[fieldName]) {
            setErrors(removeExistingError(errors, fieldName));
        }
        setBankAccountProfile((state) => ({...state, [fieldName]: value}));
    };

    return (
        <ContainerBox
            backgroundColor={COLOR.WHITE}
            pageTitle={pageTitle.loanRequest}
            showBackButton={!props.isAndroid}
        >
            <Loading active={loading} msg={"Please wait we're making changes"}/>
            {
                subStatus &&
                <>
                    {
                        subStatus.includes(LoanRequestSubStatus.LOAN_REQUEST_INCOMPLETE) &&
                        <LoanDetails
                            profile={loanProfile}
                            onChange={handleLoanProfileChange}
                            errors={errors}
                        />
                    }
                    {
                        subStatus.includes(LoanRequestSubStatus.BANK_DETAILS_INCOMPLETE) &&
                        <BankAccount
                            profile={bankAccountProfile}
                            onChange={handleBankAccountProfileChange}
                            errors={errors}
                        />
                    }
                    <Button
                        buttonText="Continue"
                        onClick={handleSubmit}
                        bgColor={COLOR.PRIMARY}
                        width={"60%"}
                    />
                </>
            }
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        screens: state.incompleteInfoV2.screens,
        profile: state?.profileInfo?.paanduProfile,
        applicationId: state?.profileInfo?.latestStatus?.applicationId,
        applicationInfo: state?.profileInfo?.latestStatus,
        isAndroid: state.login.isAndroid,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(LoanRequest);
